import { ArrowUpRight, ChevronDown } from "lucide-react";
import { useState } from "react";
import { cn } from "../utils/cn";

export default function AccordionServicos({
  title,
  text,
  icon,
  number,
  glowColor = "#A002CB",
  url,
  doesThereButton = true,
  className,
}) {
  const [isHovered, setIsHovered] = useState(false);

  function handleMouseEnter() {
    setIsHovered(true);
  }

  function handleMouseLeave() {
    setIsHovered(false);
  }

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseEnter}
      onTouchEnd={handleMouseLeave}
      className="relative hover:cursor-pointer md:hidden"
    >
      <div
        className={cn(
          'absolute inset-0 transition-opacity duration-300 blur-2xl',
          isHovered || isOpen ? 'opacity-80' : 'opacity-0',
          `bg-[${glowColor}]`,
        )}
      />
      <div
        className={cn(
          "relative z-10 rounded-lg p-5 bg-[#1B182D] text-white h-full w-full flex flex-col space-y-6",
          isOpen && "pb-6",
          className,
          isOpen && !doesThereButton && "pb-10",
        )}
      >
        <button type="button" onClick={() => setIsOpen(!isOpen)}>
          <section className="flex items-center justify-between gap-5">
            <div className="flex items-center gap-5 md:block md:space-y-6">
              <div className="relative w-fit min-w-[52px] aspect-square">
                <div
                  className={cn(
                    'absolute inset-0 rounded-full aspect-square transition-all duration-300',
                    isHovered || isOpen
                      ? 'bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] opacity-100'
                      : 'bg-white/10 blur-[2px]',
                  )}
                />
                <div className="absolute inset-[1px] aspect-square rounded-full bg-[#1B182D] flex items-center justify-center">
                  {icon ? (
                    <img
                      className="size-7 aspect-square object-contain"
                      src={icon}
                      alt={title}
                    />
                  ) : (
                    <span className="text-white font-inter-bold text-xl">{number}</span>
                  )}
                </div>
              </div>
              <h1 className="text-lg md:text-xl font-inter-bold text-left max-w-[205px]">
                {title}
              </h1>
            </div>
            <ChevronDown
              className={cn(
                "block size-8 aspect-square",
                isOpen && "rotate-180",
              )}
            />
          </section>
        </button>
        {isOpen && (
          <section className="text-sm font-inter-regular space-y-7">
            <p>{text}</p>

            {doesThereButton && (
              <a
                href={url}
                className="flex items-center gap-1 justify-center rounded-full bg-[rgba(255,255,255,0.08)] text-[rgba(248,249,250,1)] py-2 px-12 mx-auto w-fit"
              >
                Saiba mais <ArrowUpRight className="size-3" />
              </a>
            )}
          </section>
        )}
      </div>
    </div>
  );
}
